define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var core = require('core');
    var PortletView = require('modules/portlet/portlet.view');
    var Form = require('class/form.class');
    var AddCardModel = require('portlets/cashier/addcard/addcard.model');
    var user = require('user');
    var url = require('util/url.util');
    var storage = require('util/storage.util');
    var cashierUtil = require('modules/cashier/cashier.util');
    var config = require('config');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        events: _.extend({}, PortletView.prototype.events, {
            'submit form': 'addCard',
            'change .fn-fill-user-data': 'fillUserData'
        }),

        initialize: function(options) {
            this.model = new AddCardModel();
            this.options = options;
        },

        render: function() {
            this.$el.html(this.tmpl('addcard', _.extend({}, this.options.config, {
                storeCardConfirmationRequired: this.options.storeCardConfirmationRequired
            })));
            this.form = new Form(this.$('form'), {
                validationConfig: this.model.validationConfig
            });

            return this;
        },

        portletDidMount: function() {
            // continue register for fast registered players
            if (user.isFastRegistered()) {
                return user.continueRegistration();
            }
        },

        back: function() {
            var backUrl = url.getLocationParameterByName('back_url');
            var depositPage = config.get('depositPage');
            var rootPage = config.get('rootPage');

            // check if origin is safe
            var backUrlOrigin = new URL(backUrl, location.origin).origin;
            var safeOriginsCfg = this.options.config.safeOrigins || '';
            var safeOrigins = safeOriginsCfg
                .split('\n')
                .filter(origin => !_.isEmpty(origin))
                .concat([location.origin]);

            if (!safeOrigins.includes(backUrlOrigin)) {
                backUrl = null;
            }

            // specific case for add-card
            // need to handle popup behavior on
            // page change globally
            window.Playtech.API.popup.closePopups();

            var targetPage = backUrl || depositPage || rootPage;
            core.navigate(targetPage);
        },

        addCard: function(e) {
            e.preventDefault();

            this.form.validate().done(function(data, form) {
                form.showLoading();
                this.hideKeyboard();

                this.model.addCard(data)
                    .done(this.addCardSuccess.bind(this))
                    .fail(this.addCardFail.bind(this))
                    .always(form.hideLoading.bind(form));
            }.bind(this));
        },

        addCardSuccess: function(response) {
            var methods = response.data.payments.method,
                code = methods && methods[0] && methods[0].code;

            storage.session.setItem('lastAddedPayment', code);
            this.showInfo({
                content: this.translate('playtech.mobile.system.mobile-cashier.notifications.cardAdded')
            });

            core.trigger('card:added', response);

            this.back();
        },

        getNonPekoErrorMessage: function(response) {
            switch (response.data.errorCode) {
                case 4203:
                    return this.translate('playtech.mobile.system.mobile-cashier.add-card.error.inuse-by-other');
                case 4204:
                    return this.translate('playtech.mobile.system.mobile-cashier.add-card.error.invalid-type');
                case 4202:
                    return this.translate('playtech.mobile.system.mobile-cashier.add-card.error.inuse-by-me');
                case 3000:
                    return this.translate('playtech.mobile.system.mobile-cashier.add-card.error.invalid');
                default:
                    return response.data.errorMessage;
            }
        },

        addCardFail: function(response) {
            var errorMessage = cashierUtil.getErrorMessage(response) || this.getNonPekoErrorMessage(response);

            this.form.showErrorMessage({
                content: errorMessage
            });
        },

        fillUserData: function(e) {
            var elements = $('.fn-user-data').find('.fn-validate'),
                userDetails = user.get('userDetails');

            if (e.currentTarget.checked) {
                this.form.data({
                    firstName: userDetails.firstName,
                    lastName: userDetails.lastName,
                    zip: userDetails.zip,
                    billingAddress: userDetails.address,
                    city: userDetails.city,
                    countryCode: userDetails.countryCode
                });

                this.form.validate(elements);
            } else {
                this.form.clear('.fn-user-data input, .fn-user-data select');
                elements.find('select option').eq(0).attr('selected', 'selected');
            }
        },

        close: function() {
            window.Playtech.API.common.replace(url.pathname, undefined, { removeParams: ['back_url'] });
            core.trigger('backButton:show');
            PortletView.prototype.close.apply(this, arguments);
        }

    });

});
